import { Route, Routes } from 'react-router-dom';
import MerchantTransactionsPage from '../pages/merchant-pages/merchant-transaction.page';
import { GlobalRoutes } from './global.routes';

function MerchantRoutes() {
  return (
    <Routes>
      {GlobalRoutes()}
      <Route path="transactions" element={<MerchantTransactionsPage />} />
    </Routes>
  );
}

export default MerchantRoutes;
